import { Link } from 'react-router-dom'

const diferenciais = [
  {
    icon: 'fa-utensils',
    titulo: 'PDV de Mesa e Comanda',
    desc: 'Abertura de mesa, lançamento de pedidos e fechamento de conta com agilidade.',
  },
  {
    icon: 'fa-kitchen-set',
    titulo: 'Controle de Cozinha',
    desc: 'Pedidos enviados diretamente para a cozinha com controle de tempo de preparo.',
  },
  {
    icon: 'fa-boxes-stacked',
    titulo: 'Controle de Ingredientes',
    desc: 'Gestão de insumos e receitas com baixa automática de estoque por venda.',
  },
  {
    icon: 'fa-file-invoice',
    titulo: 'Emissão Fiscal',
    desc: 'Emissão de NF-e e NFC-e integrada, com transmissão automática para a SEFAZ.',
  },
]

const secoes = [
  {
    titulo: 'Atendimento e PDV',
    img: '/img/solucoes/restaurante/restaurante.jpg',
    items: [
      'Abertura e controle de mesas com status em tempo real',
      'Lançamento de pedidos por mesa, balcão ou delivery',
      'Divisão de conta por item ou igualmente entre clientes',
      'Múltiplas formas de pagamento: dinheiro, cartão, PIX, crediário',
      'Controle de garçons e comissões por atendimento',
      'Histórico de consumo e fidelização de clientes',
    ],
    cta: { label: 'Agendar Demonstração', href: '/agendar-visita' },
    imgEsquerda: true,
  },
  {
    titulo: 'Estoque e Ingredientes',
    img: '/img/solucoes/restaurante/estoque.jpg',
    items: [
      'Cadastro de receitas com lista de ingredientes e quantidades',
      'Baixa automática de estoque de insumos a cada venda',
      'Controle de validade e lote de produtos perecíveis',
      'Alertas de estoque mínimo por ingrediente',
      'Entrada de mercadorias via nota fiscal do fornecedor',
      'Inventário periódico com ajuste automático',
    ],
    cta: { label: 'Agendar Demonstração', href: '/agendar-visita' },
    imgEsquerda: false,
  },
  {
    titulo: 'Fiscal',
    img: '/img/solucoes/entrada.webp',
    items: [
      'Emissão de NFC-e (cupom fiscal eletrônico) no caixa',
      'Emissão de NF-e para eventos e vendas a pessoa jurídica',
      'Cancelamento e inutilização de documentos fiscais',
      'Transmissão automática para a SEFAZ',
      'Relatórios fiscais prontos para o contador',
    ],
    cta: { label: 'Falar com um Consultor', href: '/agendar-visita' },
    imgEsquerda: true,
  },
]

export default function SolucaoRestaurante() {
  return (
    <>
      {/* Hero */}
      <section
        className="relative bg-quantum-blue py-20 text-white bg-cover bg-center"
        style={{ backgroundImage: "url('/img/contabilidade.jpg')" }}
      >
        <div className="absolute inset-0 bg-quantum-blue/80" />
        <div className="relative max-w-7xl mx-auto px-4">
          <div className="max-w-2xl">
            <p className="text-quantum-red font-semibold uppercase tracking-widest text-sm mb-3">
              Solução para Restaurante e Lanchonete
            </p>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
              Sistema completo para restaurante e lanchonete
            </h1>
            <p className="text-blue-200 text-lg mb-8">
              Do controle de mesas ao gerenciamento de ingredientes, da comanda eletrônica à emissão
              fiscal — o Quantum foi desenvolvido para a rotina agitada do food service.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/agendar-visita"
                className="bg-quantum-red hover:bg-red-700 text-white font-bold px-8 py-4 rounded-lg transition-colors"
              >
                Agendar Demonstração
              </Link>
              <Link
                to="/solucoes"
                className="border border-white/40 hover:border-white text-white font-semibold px-8 py-4 rounded-lg transition-colors"
              >
                Ver outras soluções
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-quantum-blue text-center mb-10">
            Por que escolher o Quantum para o seu restaurante ou lanchonete?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {diferenciais.map(({ icon, titulo, desc }) => (
              <div key={titulo} className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 text-center">
                <div className="w-14 h-14 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`fa-solid ${icon} text-quantum-blue text-xl`} />
                </div>
                <h3 className="font-bold text-quantum-blue mb-2">{titulo}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Seções de funcionalidades */}
      {secoes.map(({ titulo, img, items, cta, imgEsquerda }, idx) => (
        <section key={titulo} className={`py-16 ${idx % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
          <div className="max-w-6xl mx-auto px-4">
            <div className={`flex flex-col ${imgEsquerda ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-10 items-center`}>
              <div className="w-full lg:w-1/2 flex-shrink-0">
                <img src={img} alt={titulo} className="w-full h-72 object-cover rounded-2xl shadow-md" />
              </div>
              <div className="w-full lg:w-1/2">
                <h2 className="text-2xl font-bold text-quantum-blue mb-6">{titulo}</h2>
                <ul className="space-y-3 mb-8">
                  {items.map((item) => (
                    <li key={item} className="flex items-start gap-3 text-gray-700 text-sm">
                      <i className="fa-solid fa-check text-quantum-blue mt-0.5 flex-shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
                <Link
                  to={cta.href}
                  className="inline-block bg-quantum-blue hover:bg-quantum-blue-dark text-white font-bold px-7 py-3 rounded-lg transition-colors text-sm"
                >
                  {cta.label}
                </Link>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA final */}
      <section className="py-16 bg-quantum-blue text-white text-center">
        <div className="max-w-3xl mx-auto px-4">
          <h2 className="text-3xl font-bold mb-4">Pronto para modernizar seu restaurante ou lanchonete?</h2>
          <p className="text-blue-200 mb-8">
            Fale com nosso time e agende uma demonstração sem compromisso.
          </p>
          <Link
            to="/agendar-visita"
            className="inline-block bg-quantum-red hover:bg-red-700 text-white font-bold px-10 py-4 rounded-lg transition-colors"
          >
            Agendar Demonstração Gratuita
          </Link>
        </div>
      </section>
    </>
  )
}
